export default __webpack_public_path__ + "static/media/icon-change-goal-item.f12d0545.svg";